import { FC } from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';

export interface CategoryToggleButtonProps {
  category: string;
  categoryDescription: string;
  count: number;
  isOpen: boolean;
  onToggle: () => void;
}

export const CategoryToggleButton: FC<CategoryToggleButtonProps> = ({
  category,
  categoryDescription,
  count,
  isOpen,
  onToggle,
}) => (
  <button
    type="button"
    onClick={onToggle}
    aria-expanded={isOpen}
    className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-day-light-5 transition-colors"
  >
    <span className="text-day-neutral-subtle">
      {isOpen ? <FaChevronDown size={12} /> : <FaChevronRight size={12} />}
    </span>
    <span className="flex-1 min-w-0">
      <span className="font-semibold text-day-neutral-dark">{category}</span>
      {categoryDescription && (
        <span className="ml-2 text-sm text-day-neutral-subtle">{categoryDescription}</span>
      )}
    </span>
    <span className="text-sm tabular-nums text-day-neutral-subtle">{count}</span>
  </button>
);
